"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLockBodyScroll = useLockBodyScroll;
var _react = require("react");
function useLockBodyScroll(lock) {
  (0, _react.useLayoutEffect)(function () {
    if (!lock) return;
    var _global = global,
      scrollY = _global.scrollY;
    var originalStyle = {
      top: global.document.body.style.top,
      position: global.document.body.style.position,
      width: global.document.body.style.width
    };
    global.document.body.style.position = 'fixed';
    global.document.body.style.top = "-".concat(scrollY, "px");
    global.document.body.style.width = '100%';
    return function () {
      global.document.body.style.position = originalStyle.position;
      global.document.body.style.top = originalStyle.top;
      global.document.body.style.width = originalStyle.width;
      global.scrollTo(0, scrollY);
    };
  }, [lock]);
}